import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { formasPagoAPI } from '../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import '../Clientes.css';

const FormasPago = () => {
  const [formas, setFormas] = useState([]);
  const [loading, setLoading] = useState(true);
  const { hasPermission } = useAuth();

  useEffect(() => {
    loadFormas();
  }, []);

  const loadFormas = async () => {
    try {
      setLoading(true);
      const response = await formasPagoAPI.getAll({});
      if (response.success) {
        setFormas(response.data);
      }
    } catch (error) {
      toast.error('Error al cargar formas de pago');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Está seguro de eliminar esta forma de pago?')) return;

    try {
      const response = await formasPagoAPI.delete(id);
      if (response.success) {
        toast.success('Forma de pago eliminada exitosamente');
        loadFormas();
      }
    } catch (error) {
      toast.error(error.message || 'Error al eliminar forma de pago');
    }
  };

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  return (
    <div className="clientes pagina-listado pagina-listado--scroll">
      <div className="page-header">
        <h1>Formas de Pago</h1>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {hasPermission('gestionar_usuarios') && (
            <Link to="/formas-pago/fondos-admin" className="btn-secondary">
              Matriz cajas por usuario
            </Link>
          )}
          {hasPermission('ver_movimientos') && (
            <Link to="/formas-pago/fondos-usuario" className="btn-secondary">
              Fondos por usuario
            </Link>
          )}
          {hasPermission('crear_debitos') && (
            <Link to="/formas-pago/nuevo" className="btn-primary">+ Nueva Forma de Pago</Link>
          )}
        </div>
      </div>

      <div className="listado-panel clientes-listado listado-controles">
        <div className="listado-panel-cuerpo clientes-listado-cuerpo">
          <div className="listado-tabla-area clientes-listado-tabla-area">
            <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Uso</th>
              <th>Destino (Caja / Cta. bancaria)</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {formas.length === 0 ? (
              <tr>
                <td colSpan="6" className="no-data">No hay formas de pago registradas</td>
              </tr>
            ) : (
              formas.map(forma => (
                <tr key={forma.id}>
                  <td><strong>{forma.nombre}</strong></td>
                  <td>{forma.descripcion || '-'}</td>
                  <td>
                    {forma.tipo_movimiento === 'ingreso' ? 'Ingreso' : forma.tipo_movimiento === 'egreso' ? 'Egreso' : 'Ambos'}
                  </td>
                  <td>
                    {forma.caja_nombre ? (
                      <span title="Caja">📦 {forma.caja_nombre}</span>
                    ) : forma.cuenta_banco_nombre && forma.cuenta_numero ? (
                      <span title="Cuenta bancaria">🏦 {forma.cuenta_banco_nombre} - {forma.cuenta_numero}</span>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td>
                    <span className={`badge ${forma.activo ? 'activo' : 'inactivo'}`}>
                      {forma.activo ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      {hasPermission('crear_debitos') && (
                        <>
                          <Link to={`/formas-pago/editar/${forma.id}`} className="btn-edit">Editar</Link>
                          <button onClick={() => handleDelete(forma.id)} className="btn-delete">Eliminar</button>
                        </>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormasPago;

